import axios from "../configs/axios.config";

const SERVER = import.meta.env.VITE_API_URL;

// Create vendor onboarding configuration
export const createVendorOnboardingConfig = async (payload) => {
  try {
    const response = await axios.post(
      `${SERVER}/admin/vendor-onboarding-config/new`,
      payload,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to create vendor onboarding configuration"
    );
  }
};

// Get vendor onboarding configurations
export const getVendorOnboardingConfigs = async (params = {}) => {
  try {
    const response = await axios.get(
      `${SERVER}/admin/vendor-onboarding-config/list`,
      {
        params,
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch vendor onboarding configurations"
    );
  }
};

// Get single vendor onboarding configuration
export const getVendorOnboardingConfigById = async (id) => {
  try {
    const response = await axios.get(
      `${SERVER}/admin/vendor-onboarding-config/${id}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch vendor onboarding configuration"
    );
  }
};

// Update vendor onboarding configuration
export const updateVendorOnboardingConfig = async (id, payload) => {
  try {
    const response = await axios.patch(
      `${SERVER}/admin/vendor-onboarding-config/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to update vendor onboarding configuration"
    );
  }
};

// Toggle vendor onboarding configuration status
export const toggleVendorOnboardingConfigStatus = async (id, isActive) => {
  try {
    const response = await axios.patch(
      `${SERVER}/admin/vendor-onboarding-config/${id}/toggle-status`,
      { isActive },
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to toggle vendor onboarding configuration status"
    );
  }
};

// Delete vendor onboarding configuration
export const deleteVendorOnboardingConfig = async (id) => {
  try {
    const response = await axios.delete(
      `${SERVER}/admin/vendor-onboarding-config/${id}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to delete vendor onboarding configuration"
    );
  }
};

// Get active vendor onboarding configurations
export const getActiveVendorOnboardingConfigs = async (params = {}) => {
  try {
    const response = await axios.get(
      `${SERVER}/admin/vendor-onboarding-config/active`,
      {
        params,
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch active vendor onboarding configurations"
    );
  }
};
